import { render, staticRenderFns } from "./THGCO2EquivalentForm.vue?vue&type=template&id=4c5d01eb&scoped=true"
import script from "./THGCO2EquivalentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCO2EquivalentForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGCO2EquivalentForm.vue?vue&type=style&index=0&id=4c5d01eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d01eb",
  null
  
)

export default component.exports